<template>
	<div class="ss-modal" :class="{'ss-modal-active': modalActive}">
		<div class="ss-mask" @click="closeMask" />
		<div class="ss-popup" :style="style_">
			<slot></slot>
			<div class="ss-close" @click="hide" v-show="showClose" :class="{'ss-close-bottom': closeMode === 'bottom'}" ></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'bestModal',
		props: { 
			/**
			 * 显示模式
			 */
			mode: {
				type: String,
				default: 'insert'
			},
			closeMode: {
				type: String,
				default: 'right'
			},
			maskClose: {
				type: [String, Boolean],
				default: false
			},
			showClose: {
				type: [String, Boolean],
				default: true
			},
			value: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				modalActive: false,
				width: 0,
				height: 0,
				showPop: false,
				modalId: null
			}
		},
		watch: {
			value: {
				handler(val) {
					let modalId = this.modalId
					let modalStorage = this.$local.get('modalIds') || [];
					if(val){
						if(modalId){
							modalStorage.push(modalId);
							modalStorage = Array.from(new Set(modalStorage));
						}
						this.calcModal();
						setTimeout(() => {
							this.modalActive = true;
						}, 50)
					}else{
						let modalIndex = modalStorage.findIndex(o => o === modalId);
						modalIndex !== -1 && modalStorage.splice(modalIndex, 1);
						this.modalId = null;
						this.modalActive = false;
					}
					this.$local.set('modalIds', modalStorage);
					if(modalStorage.length){
						document.querySelector('body').classList.add("ss-modal-open");
					}else{
						document.querySelector('body').classList.remove("ss-modal-open");
					}
				},
				immediate: true,  //刷新加载 立马触发一次handler
			}
		},
		computed: {
			showClose_() {
				return String(this.showClose) === 'false' ? false : true;
			},
			maskClose_ (){
				return String(this.maskClose) === 'false' ? false : true;
			},
			style_() {
				return {
					marginTop: -this.height / 2 + 'px',
					marginRight: -this.width / 2 + 'px'
				}
			}
		},
		created() {
			this.modalId = Math.random().toString(32).substr(2);
		},
		methods: {
			calcModal() {
				this.$nextTick(() => {
					setTimeout(() => {
						let { width, height } = document.querySelector('.ss-popup').getBoundingClientRect();
						this.width = width;
						this.height = height;
					}, 1)
				})
			},
			hide() {
				this.$emit('input', false);
			},
			closeMask() {
				if (!this.maskClose_) return ;
				this.$emit('input', false);
			}
		}
	}
</script>
<style lang="scss" scoped>
	.ss-modal{
		opacity: 0;
		pointer-events: none;
		transform: scale(1.2);
		@include fixed(0, 0, 0, 0);
		@include tst(all, .15s);
		z-index: 997;
		.ss-mask {
			position: fixed;
			z-index: 998;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(0, 0, 0, 0.3);
		}

		.ss-popup {
			@include fixed(50%, 50%);
			z-index: 999;
		}
		.ss-close {
			@include abs(20px, 20px);
			display: block;
			z-index: 2;
			cursor: pointer;
			@include tst();
			width: 30px;
			height: 30px;
			background: url(~@/assets/img/setting/guanbi@2x.png) center center / 24px auto no-repeat;
			&:hover{
				background-image: url(~@/assets/img/main/close-hover.png);
			}
		}
		.ss-close-bottom{
			bottom: -15px;
			right: 50%;
			margin-right: -15px;
		}
		&.ss-modal-active{
			transform: scale(1);
			opacity: 1;
			pointer-events: auto;
			& > .ss-popup-bottom, & > .ss-popup-top, & > .ss-popup-cover, & > .ss-popup-right{
				transform: translate(0, 0);
			}
		}
	}
</style>